import { render } from "./ServiceDetails4.vue?vue&type=template&id=5d8f4a20&scoped=true"
import script from "./ServiceDetails4.vue?vue&type=script&lang=js"
export * from "./ServiceDetails4.vue?vue&type=script&lang=js"

import "./ServiceDetails4.vue?vue&type=style&index=0&id=5d8f4a20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8f4a20"]])

export default __exports__